import { Checkbox, Flex, FormControl, Textarea } from '@chakra-ui/react';
import { Field } from 'formik';
import { KText } from '@/ui-library/components/text';
import { DescriptionField } from './Description';

export const Feedback = () => {
  return (
    <Flex
      border="1px solid"
      borderColor="border-color"
      p="20px"
      borderRadius="sm"
      flexDir="column"
      gap="10px"
      mt="6px"
      data-test-id="section-feedback"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap="12px"
      >
        <KText color="secondary-900" size="sm-medium">
          Feedback
        </KText>
        <Flex as="label" gap="12px" alignItems="center" cursor="pointer">
          <Field name="is_feedback_mandatory">
            {({ field }) => (
              <FormControl gap="6px" display="flex" alignItems="center">
                <Checkbox
                  {...field}
                  isChecked={field?.value === 'true' || field?.value === true}
                />
                <KText
                  size="sm-medium"
                  data-test-id="mark-feedback-as-mandatory"
                >
                  Mandatory
                </KText>
              </FormControl>
            )}
          </Field>
        </Flex>
      </Flex>
      <DescriptionField name="feedback_description" />
      <Textarea
        placeholder="Feedback goes here..."
        isDisabled
        _hover={{}}
        resize="none"
        border="1px solid"
        borderColor="border-color"
        fontSize="12px"
        _placeholder={{
          color: 'secondary-500',
        }}
        opacity="1 !important"
        data-test-id="input-feedback"
      />
    </Flex>
  );
};
